import { Component } from 'react'
class SectionXCBASE extends Component {

    state= {
        content: [
            { 
                emoji: "🔍",
                name: "Explorer",
                link: ["https://explorer.bitquery.io/bsc/token/0x2c6297eb0ea253b0bfb06971c98066e853a1084c"],
                linkTitle: ["Bitquery"],
                indications:""
            },
            { 
                emoji: "📃",
                name: "Contract",
                link: ["https://bscscan.com/address/0x2c6297eb0ea253b0bfb06971c98066e853a1084c"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💲",
                name: "Token",
                link: ["https://bscscan.com/token/0x2c6297eb0ea253b0bfb06971c98066e853a1084c"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💸",
                name: "Trade",
                link: ["https://dex.guru/token/0x2c6297eb0ea253b0bfb06971c98066e853a1084c-bsc",
                        "https://exchange.pancakeswap.finance/#/swap"],
                        linkTitle: ["dex.guru","PancakeSwap"],
                indications:`Add address "0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c" to "Select a token" and set SLIPPAGE 12% in the options.`
            },
            { 
                emoji: "🧫",
                name: "Liquidity pool",
                link: ["https://exchange.pancakeswap.finance/#/add/BNB"],
                linkTitle: ["PancakeSwap"],
                indications: `Add  address "0x2c6297eb0ea253b0bfb06971c98066e853a1084c" to "Select a currency".`
            },
            { 
                emoji: "🔒",
                name: "Liquidity lock",
                link: ["https://bscscan.com/address/0x8B593B1Cd5E36d2E363C22570C4495d65Cc21402"],
                linkTitle: ["Timelock Contract"],
                indications:""
            },
            { 
                emoji: "📈",
                name: "Chart",
                link: ["https://charts.bogged.finance/?token=0x2c6297eb0ea253b0bfb06971c98066e853a1084c",
                        "https://poocoin.app/tokens/0x2c6297eb0ea253b0bfb06971c98066e853a1084c"],
                        linkTitle: ["BoggedFinance","PooCoin"],
                indications:""
            },
            { 
                emoji: "🔥",
                name: "Staking",
                link: ["https://stak.cbase.ctena.finance/"],
                linkTitle: ["Stake CBASE-BNB CAKELP"],
                indications:""
            },
            { 
                emoji: "🔒",
                name: "Mint",
                link: ["https://mint.xcbase.ctena.finance"],
                linkTitle: ["Mint xCBASE"],
                indications:"XBASE Compound Token"
            },
        ]
    }

     copyToClipboard = (e) => {
        const el = document.createElement('textarea');
        el.value = "0x2c6297eb0ea253b0bfb06971c98066e853a1084c";
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        e.target.innerHTML=" Copied! :)";
        setTimeout(() => {
            e.target.innerHTML=" Copy Address";  
        }, 3000);
      };
      
    render () {
        return (
            <div className="section-wrap" id="xcbase-wrap">
                <p id="faq-title">xCBASE</p>
                <div id="intro-buttons">
                <a href="https://icscbase.ctena.finance/"><button>Dashboard</button></a>
                <a href="https://stak.xcbase.ctena.finance/"><button>Staking</button></a>
                <a href="https://mint.xcbase.ctena.finance/"><button>Mint</button></a>            
                <a href="https://swap.arken.finance/tokens/bsc/0x2c6297eb0ea253b0bfb06971c98066e853a1084c"><button>Buy</button></a>
                <a href="https://pancakeswap.finance/add/BNB/0x2c6297eb0ea253b0bfb06971c98066e853a1084c"><button>Add Liquidity</button></a>
                </div>    
                <div className="section-wrap" id="faq-wrap">
                <div id="info-txt">
                    <p>
                    How does <span>xCBASE</span> work? <br></br>
                    xCBASE can only be created by 🔐 locking $CBASE
                    Lock CBASE to mint xCBASE
                    Burn xCBASE to redeem CBASE
                    </p>
                </div>
                </div>
                { this.state.content.map( (box, index) => (
                    <div key={index} className="question-box">
                        <p className="question-q"><span className="question-q1">{box.emoji}</span>
                            <span className="question-q2">{box.name}</span>
                            {(box.indications === "")? null : <span class="copy-address-button" onClick={e => this.copyToClipboard(e)}> Copy Address </span>}
                        </p>
                        <div  className="question-boxForButtons">
                            {box.link.map( (link, index) => <a href={link} target="_blank"><button key={index}> {box.linkTitle[index]}</button> </a>)}
                        </div>
                        {(box.indications === "")? null : <p key={index} className="question-indications"> {box.indications}</p>}
                    </div>
                ))
                }
            </div>
        )
    }
}

export default SectionXCBASE
